var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuLocationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 0.664062C4.83935 0.664062 0.666016 4.8374 0.666016 9.9974C0.666016 16.9974 9.99935 27.3307 9.99935 27.3307C9.99935 27.3307 19.3327 16.9974 19.3327 9.9974C19.3327 4.8374 15.1593 0.664062 9.99935 0.664062ZM9.99935 13.3307C8.15935 13.3307 6.66602 11.8374 6.66602 9.9974C6.66602 8.1574 8.15935 6.66406 9.99935 6.66406C11.8393 6.66406 13.3327 8.1574 13.3327 9.9974C13.3327 11.8374 11.8393 13.3307 9.99935 13.3307Z",
    fill: "#F15355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuLocationRed);
export default __webpack_public_path__ + "static/media/DuLocationRed.fbc66917.svg";
export { ForwardRef as ReactComponent };